<div class="row m-0 {{this.getStyleClass()}} {{this.getTypeStyle()}}"
    [class.summary-row-bottom-separation]="this.getIsDivided() && this.getIsSummaryType() && this.getShowBorders()"
    [class.summary-no-row-bottom-separation]="!this.getIsDivided() && this.getIsSummaryType() && this.getShowBorders()"
    [class.summary-row-top-separation]="this.getIsDividedTop() && this.getIsSummaryType() && this.getShowBorders()"
    #row
    [id]="this.rowId"
    [style.width]="this.getSize() + '%'">
  <ng-container #target></ng-container>
  <hr  *ngIf="!this.getIsDivided() && this.getIsSummaryType() && this.getShowBorders()" class="row-separator" >
</div>